import { DOCUMENT_BLOCK_TYPES, DOCUMENT_ALIGN } from "./schema";

/** Live preview / PDF source: mirrors `templates/autorizacao_venda_imovel.md`. */
const autorizacaoVendaImovel = {
  id: "autorizacao-venda-imovel",

  blocks: [
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "AUTORIZAÇÃO PARA VENDA DE IMÓVEL",
      align: DOCUMENT_ALIGN.LEFT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "AUTORIZADOR(ES) (PROPRIETÁRIO)",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{PROPRIETARIOS}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "AUTORIZADO(S) (INTERMEDIADOR)",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{INTERMEDIADOR}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "As partes acima identificadas firmam a presente AUTORIZAÇÃO PARA INTERMEDIAÇÃO DE NEGÓCIO IMOBILIÁRIO, que será regida pelas cláusulas abaixo, de forma clara e transparente.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "CLÁUSULAS",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1) OBJETO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.1) O presente instrumento tem por objetivo autorizar o AUTORIZADO a intermediar a venda do imóvel abaixo descrito:",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1.1.1) {TIPO_IMOVEL}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.2) O AUTORIZADO poderá divulgar o imóvel utilizando os meios que habitualmente trabalha, incluindo anúncios, redes sociais, contato com clientes e visitas ao imóvel, sempre buscando a melhor oportunidade de negociação.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2) MODALIDADE",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.1) Esta autorização é concedida em caráter de {EXCLUSIVIDADE}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.2) O AUTORIZADO atuará como intermediador, não possuindo poderes para concluir a venda sem a aprovação do AUTORIZADOR.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "3) PRAZO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.1) A presente autorização terá validade de {PRAZO_AUTORIZACAO} meses, a partir da data de assinatura.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.2) Caso não haja manifestação contrária por escrito, o prazo será renovado automaticamente por igual período.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "4) NEGOCIAÇÃO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.1) Propostas com condições diferentes das inicialmente previstas poderão ser avaliadas em conjunto pelas partes, sempre buscando um acordo que seja interessante para todos.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.2) Nenhuma proposta será aceita sem o consentimento do AUTORIZADOR.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "5) COMISSÃO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.1) Em caso de venda do imóvel, será devida ao AUTORIZADO a comissão de {COMISSAO}% sobre o valor da negociação.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.2) A comissão também será devida caso a venda seja concretizada após o término desta autorização, desde que reste comprovado que o negócio decorreu da atuação do AUTORIZADO, especialmente nos casos em que o comprador tenha sido por ele apresentado, atendido ou aproximado durante o período de vigência deste instrumento.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.3) A comissão também será devida caso a venda seja concretizada após o término desta autorização, desde que o comprador tenha sido apresentado durante sua vigência.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "6) DECLARAÇÕES",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "O AUTORIZADOR declara que:",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "6.1) Possui legitimidade para vender o imóvel;",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "6.2) As informações fornecidas são verdadeiras;",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "6.3) O imóvel está apto à negociação, salvo condições previamente informadas.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "7) DISPOSIÇÕES GERAIS",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "7.1) Este instrumento não gera vínculo empregatício entre as partes.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "7.2) As partes comprometem-se a agir com boa-fé e transparência durante toda a negociação.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "ENCERRAMENTO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "POR ESTAREM DE ACORDO, assinam a presente autorização.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CIDADE_ASSINATURA}, {DATA_ASSINATURA}.",
      align: DOCUMENT_ALIGN.RIGHT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 3 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "AUTORIZADOR(ES)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_PROPRIETARIOS}",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_PROPRIETARIOS}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "AUTORIZADO(S)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_INTERMEDIADOR}",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "TESTEMUNHAS" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_TESTEMUNHAS}",
    },
  ],
};

export default autorizacaoVendaImovel;
